import { tvModeActive } from '@classes/app_url_params'
import Logger from '@logger'
import { isNumber } from 'lodash'
import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

const logger = Logger.create('yisNavigate')

// const tvm = 'tvmode=true'

let wasInTvMode = false

export function useYisNavigate (): NavigateFunction {
  const nav = useNavigate()

  return (to: To | number, options?: NavigateOptions) => {
    if (isNumber(to)) {
      nav(to)
      return
    }

    if (tvModeActive()) {
      wasInTvMode = true
    }

    logger.verbose(`will navigate to ${to}`)

    if (wasInTvMode && Math.random() > 1) {
      console.log({ wasInTvMode })
    }

    nav(to, options)
  }
}
